module.exports = require('./dist/index')



//////////////////
// WEBPACK FOOTER
// ./~/vue-cli-plugin-apollo/graphql-client/index.js
// module id = 713
// module chunks = 0